import React, { PureComponent } from 'react';
import styles from '~/CzReimbursement/styles.less';
import { DebounceInput } from '~/Debounce';
import defaultInputStyles from '~/UI/Input/compact.less';
import Input from '~/UI/Input/Input';
import SaveActivityIndicator, { Status } from '~/UI/SaveActivityIndicator/SaveActivityIndicator';

export interface Value {
	value: string;
	isValid: boolean | null;
}

export interface Values {
	packageSize: Value;
	dosageStrength: Value;
	usualTherapeuticDailyDose: Value;
	usualTherapeuticDailyDosePerPackage: Value;
}

interface Props {
	updateStatus: Status | null;
	values: Values;
	onValueChange(fieldName: string, value: any): void;
	onSave(): void;
}

export default class ParametersPanel extends PureComponent<Props> {
	render() {
		const { updateStatus } = this.props;

		return (
			<div className={styles.header} data-testid='parameters-panel'>
				<div className={styles.in}>
					<div className={styles.parameters}>
						<p className={styles.parametersDescription}>Reimbursement calculation parameters:</p>

						{this.renderPackageSize()}
						{this.renderDosageStrength()}
						{this.renderUsualTherapeuticDailyDose()}
						{this.renderUsualTherapeuticDailyDosePerPackage()}

						<SaveActivityIndicator
							hideAfterMilliseconds={3000}
							status={updateStatus}
							testId='parameters-panel-save-indicator'
						/>

						<p className={styles.parametersWarning}>
							Warning: Parameters for calculation are automatically imported from SCAU, please check the correctness.
							SCAU provides ODTBAL with 4 decimal places only.
						</p>
					</div>
				</div>
			</div>
		);
	}

	renderPackageSize() {
		const {
			values: { packageSize },
			onValueChange,
			onSave,
		} = this.props;

		return (
			<label className={styles.parameterLabel} htmlFor='reference-package-size'>
				<span className={styles.parameterLabelText}>Package size:</span>
				<div className={styles.parameterInput}>
					<DebounceInput
						value={packageSize.value}
						onBlur={onSave}
						onChange={(value) => onValueChange('packageSize', value)}
					>
						<Input id='reference-package-size' isInvalid={packageSize.isValid === false} styles={defaultInputStyles} />
					</DebounceInput>
				</div>
			</label>
		);
	}

	renderDosageStrength() {
		const {
			values: { dosageStrength },
			onValueChange,
			onSave,
		} = this.props;

		return (
			<label className={styles.parameterLabel} htmlFor='reference-dosage-strength'>
				<span className={styles.parameterLabelText}>Dosage Strength:</span>
				<div className={styles.parameterInput}>
					<DebounceInput
						value={dosageStrength.value}
						onBlur={onSave}
						onChange={(value) => onValueChange('dosageStrength', value)}
					>
						<Input
							id='reference-dosage-strength'
							isInvalid={dosageStrength.isValid === false}
							styles={defaultInputStyles}
						/>
					</DebounceInput>
				</div>
			</label>
		);
	}

	renderUsualTherapeuticDailyDose() {
		const {
			values: { usualTherapeuticDailyDose },
			onValueChange,
			onSave,
		} = this.props;

		return (
			<label className={styles.parameterLabel} htmlFor='reference-usual-therapeutic-daily-dose'>
				<span className={styles.parameterLabelText} title='Obvyklá Denní Terapeutická Dávka'>
					ODTD:
				</span>
				<div className={styles.parameterInputUTDD}>
					<DebounceInput
						value={usualTherapeuticDailyDose.value}
						onBlur={onSave}
						onChange={(value) => onValueChange('usualTherapeuticDailyDose', value)}
					>
						<Input
							id='reference-usual-therapeutic-daily-dose'
							isInvalid={usualTherapeuticDailyDose.isValid === false}
							styles={defaultInputStyles}
						/>
					</DebounceInput>
				</div>
			</label>
		);
	}

	renderUsualTherapeuticDailyDosePerPackage() {
		const {
			values: { usualTherapeuticDailyDosePerPackage },
			onValueChange,
			onSave,
		} = this.props;

		return (
			<label className={styles.parameterLabel} htmlFor='reference-usual-therapeutic-daily-dose-per-package'>
				<span className={styles.parameterLabelText} title='Obvyklá Denní Terapeutická Dávka Balení'>
					ODTDBAL:
				</span>
				<div className={styles.parameterInputUTDD}>
					<DebounceInput
						value={usualTherapeuticDailyDosePerPackage.value}
						onBlur={onSave}
						onChange={(value) => onValueChange('usualTherapeuticDailyDosePerPackage', value)}
					>
						<Input
							id='reference-usual-therapeutic-daily-dose-per-package'
							isInvalid={usualTherapeuticDailyDosePerPackage.isValid === false}
							styles={defaultInputStyles}
						/>
					</DebounceInput>
				</div>
			</label>
		);
	}
}
